var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18.0298 43.0218C15.2395 38.9298 13.375 31.4938 13.375 23C13.375 14.5061 15.2395 7.07015 18.0298 2.97815",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M27.9702 43.0218C30.7605 38.9298 32.625 31.4938 32.625 23C32.625 14.5061 30.7605 7.07015 27.9702 2.97815",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M2.4209 21.625H43.6251",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M6.49829 10.625H39.5001",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5",
    d: "M4.75464 32.625H41.2416",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6251 23C43.6318 27.4535 42.1905 31.7884 39.5184 35.3512L43.6251 43.625L32.6251 41.2417C24.4329 45.5648 14.3635 43.8967 8.00305 37.1628C1.64256 30.4289 0.551011 20.2809 5.33395 12.3483C10.1169 4.41584 19.6012 0.64453 28.5253 3.12658C37.4495 5.60863 43.6247 13.7353 43.6251 22.9982V23Z",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.6fb8a6a7a3f591b9943e196cb8572832.svg";
export { ForwardRef as ReactComponent };